// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3HGBN","itemTitle":"ClientEmergencyInfo_itemTitle__HSDOx","itemText":"ClientEmergencyInfo_itemText__18A4Z"};